module.exports = __webpack_public_path__ + "static/media/LandBuilding2.7746df78.svg";